import type { ProductType } from '@/types'
import SearchForm from '@/components/Hotels/HorizonForm/HorizonHotelForm'
import FlightForm from '@/components/Flights/HorizonForm/HorizonFlightForm'
import { handleSubmitForHotels } from '@/components/Hotels/SearchForm/utils'

import { onSubmit as onSubmitFlight } from '@/components/Flights/SearchForm/utils'
import CarsForm from '@/components/Cars/HorizonForm/HorizonCarForm'
import HorizonPackagesForm from '@/components/Packages/HorizonForm/HorizonPackagesForm'
import { onSubmit } from '@/components/Packages/SearchForm/utils'
import HorizonCruiseForm from '@/components/Cruises/HorizonForm/HorizonCruiseForm'

export default function getProductCategory(productType: ProductType) {
  switch (productType) {
    case 'flights':
      return {
        component: <FlightForm onSubmit={onSubmitFlight} pageName="homepage" />
      }
    case 'cars':
      return {
        component: <CarsForm />
      }
    case 'vacations':
      return {
        component: (
          <HorizonPackagesForm pageName="homepage" onSubmit={onSubmit} />
        )
      }

    case 'cruises':
      return {
        component: <HorizonCruiseForm />
      }

    default:
      return {
        component: (
          <SearchForm
            onSubmit={handleSubmitForHotels}
            showHotelTypeButtons
            pageName="homepage"
          />
        )
      }
  }
}
